import { FDSColors } from '@fountain/fds-tokens';
import { StatusLabelPalette } from 'src/types';

export const CustomColors = {
  amber50: '#FFF8E1',
  amber800: '#92400E',
};

export interface AvatarColors {
  BLUE_1: string;
  GREEN_1: string;
  GREEN_2: string;
  ORANGE: string;
  ORANGE_2: string;
  PINK: string;
  PURPLE: string;
  RED: string;
  TEAL: string;
}

export interface IconColors {
  GREEN_100: string;
  PURPLE_200: string;
  PINK_100: string;
  PURPLE_100: string;
}

export interface SpecialColors {
  Avatar: AvatarColors;
  Icon: IconColors;
  StatusLabel: StatusLabelPalette;
}

export const SpecialColors: SpecialColors = {
  Avatar: {
    BLUE_1: '#4147D9',
    GREEN_1: '#188038',
    GREEN_2: '#2EC73E',
    ORANGE: '#FBB32B',
    ORANGE_2: '#F25D09',
    PINK: '#FD22C1',
    PURPLE: '#8B4FFB',
    RED: '#F63063',
    TEAL: '#2EC9C2',
  },
  Icon: {
    GREEN_100: 'rgba(153, 207, 0, 0.16)',
    PINK_100: 'rgba(242, 85, 236, 0.16)',
    PURPLE_100: 'rgba(151, 101, 255, 0.16)',
    PURPLE_200: 'rgba(76, 83, 255, 0.16)',
  },
  StatusLabel: {
    HoverColor: {
      ACTION: FDSColors.blue500,
      INCOMPLETE: '#F9E094', // yellow
      IN_PROGRESS: '#D4B9E9', // purple
      PARTNER: FDSColors.gray300, // grey
      SUCCESS: '#ACE7BC', // green
      WARNING: '#FFC2D4', // red
    },
    IconColor: {
      ACTION: FDSColors.white,
      INCOMPLETE: '#A88407', // yellow
      IN_PROGRESS: '#793AAF', // purple
      PARTNER: FDSColors.gray800, // grey
      SUCCESS: '#00974E', // green
      WARNING: '#C20D42', // red
    },
    LabelColor: {
      ACTION: FDSColors.blue400,
      INCOMPLETE: '#FFEEBD', // yellow
      IN_PROGRESS: '#E5D5F2', // purple
      PARTNER: FDSColors.gray200, // grey
      SUCCESS: '#D4F3DE', // green
      WARNING: '#FFDDE7', // red
    },
  },
};

export const Fonts = {
  ARIAL: 'Arial',
  BOLD: 'CircularXXWeb-Bold',
  BOOK: 'CircularXXWeb-Book',
  HELVETICA: 'Helvetica',
  HELVETICA_NEUE: 'Helvetica Neue',
  MEDIUM: 'CircularXXWeb-Medium',
  SANS: 'sans-serif',
};

export const fallbackFamily = `${Fonts.HELVETICA_NEUE},${Fonts.HELVETICA},${Fonts.ARIAL},${Fonts.SANS}`;
export const bookFamily = `${Fonts.BOOK},${fallbackFamily}`;
export const boldFamily = `${Fonts.BOLD},${fallbackFamily}`;
export const mediumFamily = `${Fonts.MEDIUM},${fallbackFamily}`;
